export function resolveTenantId(): string {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "demo";
  }

  // {tenant}.trust.buffalosentinel.com -> tenant
  const parts = hostname.split(".");
  if (parts.length >= 3) {
    return parts[0];
  }

  return "unknown";
}
